import {StyleSheet} from 'react-native';
import React, {useState} from 'react';
import CCColors from '@/Utils/CCColors';
import {MaterialCommunityIcons} from '@expo/vector-icons';
import LinkModal from '@/Screens/Books/components/LinkPopup';
import SupportModal from '@/Components/UserAssistance/component/SupportModal';

interface NotificationData {
  title: string;
  message: string;
  icon: string;
  action: string;
}

interface ClassroomNotificationProps {
  notificationData: NotificationData | null;
  handleNotificationClose: () => void;
  showPopUp: boolean;
}

const ClassroomNotification: React.FC<ClassroomNotificationProps> = ({
  notificationData,
  handleNotificationClose,
  showPopUp,
}) => {
  const [raiseIssueModal, setRaiseIssueModal] = useState<boolean>(false);
  const ICON_MAP = {
    '1': {
      name: 'close',
      bgColor: CCColors.WrongMoves.Background,
      iconColor: CCColors.White,
    },
    '2': {
      name: 'information-variant',
      bgColor: CCColors.WrongMoves.Background,
      iconColor: CCColors.White,
    },
    '3': {
      name: 'exclamation',
      bgColor: CCColors.WrongMoves.Background,
      iconColor: CCColors.White,
    },
    '4': {
      name: 'exclamation-thick',
      bgColor: CCColors.WrongMoves.Background,
      iconColor: CCColors.White,
    },
  };

  if (!showPopUp || !notificationData) {
    return null;
  }

  const closeRaiseIssueModal = () => {
    setRaiseIssueModal(false);
    handleNotificationClose();
  };
  const iconKey = String(notificationData.icon);
  const config = ICON_MAP[iconKey] || ICON_MAP['1'];

  const handleActionPress = () => {
    if (notificationData.action && notificationData.action === 'No action') {
      handleNotificationClose();
    }
    if (
      notificationData.action &&
      notificationData.action === 'Raise an issue'
    ) {
      setRaiseIssueModal(true);
    }
  };

  const hasAction =
    notificationData.action && notificationData.action !== 'No action';

  return (
    <>
      {notificationData.title && (
        <LinkModal
          showConfirm={showPopUp}
          handleCtaTitle1Press={handleActionPress}
          ctaTitle1={hasAction ? notificationData.action : undefined}
          handleCtaTitle2Press={handleNotificationClose}
          handleClose={handleNotificationClose}
          ctaTitle2="Okay"
          iconImage={
            <MaterialCommunityIcons
              name={config.name}
              color={config.iconColor}
              size={45}
            />
          }
          titleText={notificationData.title}
          description={notificationData.message}
          highlight1={false}
          highlight2={true}
          backgroundColor={config.bgColor}
          borderColor={config.bgColor}
        />
      )}
      <SupportModal
        openModal={raiseIssueModal}
        handleClose={closeRaiseIssueModal}
      />
    </>
  );
};

export default ClassroomNotification;
